/**
 * Represents types of audit events for users.
 */
export enum UserAuditEventTypeModel {
	/**
	 * A user was created.
	 */
	CreateUser = 1,
	/**
	 * An existing user was updated.
	 */
	UpdateUser = 2,
	/**
	 * A user was deleted.
	 */
	DeleteUser = 3
}
